import type { RichTreeViewProProps } from "@mui/x-tree-view-pro";
import React, { forwardRef, HTMLAttributes, Ref } from "react";
import { useTranslation } from "react-i18next";
import { RateBuilderTreeHeader } from "@sinch/components/application/RatelistBuilder/BuilderTree/RateBuilderTreeHeader";
import { RateBuilderTreeRoot } from "@sinch/components/application/RatelistBuilder/BuilderTree/RateBuilderTreeRoot";
import { TreeDnDProvider } from "@sinch/components/application/RatelistBuilder/BuilderTree/TreeDnDProvider";
import { RateBuilderItemToolsBar } from "@sinch/components/application/RatelistBuilder/RateTreeItem/RateBuilderItemToolsBar";
import { RateBuilderTreeViewItem } from "@sinch/components/application/RatelistBuilder/types";
import { IntersectionRendererProvider } from "@sinch/components/IntersectionRenderer/IntersectionRendererProvider";

export const RateBuilderRoot = forwardRef(
  (
    {
      children,
      ...props
    }: HTMLAttributes<HTMLUListElement> & { ownerState: RichTreeViewProProps<RateBuilderTreeViewItem, false> },
    ref: Ref<HTMLUListElement>
  ) => {
    const { t } = useTranslation();

    return (
      <IntersectionRendererProvider intersectionObserverOptions={{ threshold: 0, rootMargin: "100% 0px 100% 0px" }}>
        <TreeDnDProvider>
          <RateBuilderTreeRoot
            ref={ref}
            rootToolbar={<RateBuilderItemToolsBar label={t("RateBuilder.addRate")} parentId={null} />}
            {...props}
          >
            <RateBuilderTreeHeader />
            {children}
          </RateBuilderTreeRoot>
        </TreeDnDProvider>
      </IntersectionRendererProvider>
    );
  }
);
RateBuilderRoot.displayName = "RateBuilderRoot";
